import { useEffect, useState } from 'react';
import { useGlobalContext } from '~/context/GlobalContext';
import { useDeviceType } from '~/hooks/useDeviceType';
import styles from './TextInput.module.css';
import { IMessage } from '~/types/common';

const TextInput = ({ textInputRef = null }: any) => {
  const { context, setContext } = useGlobalContext();
  const deviceType = useDeviceType();
  const isMobile = (deviceType === 'mobile');

  // ODPISYWANIE NA WIADOMOŚĆ
  useEffect(() => {
    const handleReply = (e: any) => {
      const input = textInputRef?.current;
      const message: IMessage = e.detail;

      // const userName = e.detail?.userName;

      if (!input || !message.userName) return;

      const replyText = `@${message.userName} `;

      // Jeśli w polu jest już tekst, doklejamy po spacji, jeśli puste - wstawiamy na początek
      if (input.value && !input.value.endsWith(' ')) {
        input.value += ` ${replyText}`;
      } else {
        input.value += replyText;
      }

      // Ustawiamy kursor na końcu i wymuszamy focus
      input.setSelectionRange(input.value.length, input.value.length);
      input.focus();

      // Dopasowujemy wysokość textarea
      handleResize();
    };

    window.addEventListener('replyToUser', handleReply);
    return () => window.removeEventListener('replyToUser', handleReply);
  }, [textInputRef]);

  useEffect(() => {
    const input = textInputRef?.current;
    if (!input) return;

    // Obsługa wstawiania mediów (emotikon)
    if (context.media) {
      input.value += context.media;
      input.setSelectionRange(input.value.length, input.value.length);
      input.focus();
      setContext((prev: any) => ({ ...prev, media: "" }));
      handleResize(); // Wywołujemy od razu po dodaniu tekstu
    }

    // Rejestracja zdarzeń dla ręcznego wpisywania
    input.addEventListener('input', handleResize);
    handleResize(); // Uruchom przy zmianie pokoju (context.room)

    return () => input.removeEventListener('input', handleResize);
  }, [textInputRef, context.media, context.room, setContext]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const input = textInputRef?.current;
      if (!input || !input.value.trim()) return;

      window.dispatchEvent(new CustomEvent('userMessage', {
        bubbles: true,
        detail: {
          type: 'userMessage',
          value: input.value,
          roomId: context.room?.id || ''
        },
      }));

      input.value = '';
      input.style.height = '40px';
      input.style.overflowY = 'hidden';
      setContext((prev: any) => ({ ...prev, media: "", isActiveEmoticonContainer: false }));
    }
  };

  const handleResize = () => {
    const input = textInputRef?.current;
    if (!input) return;

    const baseHeight = 40;
    input.style.height = `${baseHeight}px`;
    const scrollHeight = input.scrollHeight;
    const maxHeight = parseInt(getComputedStyle(input).maxHeight, 10) || 150;

    if (scrollHeight > maxHeight) {
      input.style.height = `${maxHeight}px`;
      input.style.overflowY = 'auto';
    } else {
      input.style.height = `${scrollHeight}px`;
      input.style.overflowY = 'hidden';
    }
  };

  return (
    <textarea
      ref={textInputRef}
      id="textInput"
      maxLength={1520}
      className={styles.textInput}
      placeholder="Napisz wiadomość..."
      autoComplete="off"
      readOnly={isMobile}
      onTouchStart={() => isMobile && (textInputRef.current.readOnly = false)}
      onBlur={() => isMobile && (textInputRef.current.readOnly = true)}
      onKeyDown={handleKeyDown}
    />
  );
};

export default TextInput;